/*=========================================================================================
  File Name: helperActions.js
  Description: Vuex Store - starred pages
==========================================================================================*/

export default {
    clearMessages({commit}) {
        commit('CLEAR_MESSAGES');
    },
};
